<template>
  <div class="body-container order-page">
    <orderList ref="list" :pageFlag="pageFlag" @setListParams="setListParams" @listCallback="listCallback"></orderList>
  </div>
</template>

<script>
import orderList from "@/components/order/list";
import {pageTools,common} from "@/api/mixins";
export default {
  mixins:[pageTools,common],
  components:{orderList},
  data() {
    return {
      pageFlag:'dzbdPage',
      listLoading:false,
      showSelectPanel:false,//账户类型弹窗
      type:"1",
      typeName:"全部账户",
      name: "",//投/被人姓名
      startTime:"",
      endTime:"",
      incomes:"",//服务费
      totalFee:"",//保费
      ordersNum:"",//订单数
      activeIndex: 1,
      list:[],
    };
  },
  mounted() {
    if(!this.checkLogin()){
      return;
    }
    // 查询订单列表
    this.$weixin.hideMenu();
    // 初始化列表
    this.$refs.list.init();
  },
  methods: {
    listCallback(res){
      this.listLoading = false;
      this.list = res.data;
    },
    //设置产品参数
    setListParams(params){
      this.listLoading = true;
      this.$refs.list.listUrl = `/api/getMyPolicy`;

      return params
    },
    // 列表跳转
    goPage(url, params, e) {
      if(e.target.className.indexOf("copy") != -1){
        return;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
  },

};
</script>

<style lang="scss" scoped>
@import "./list";
</style>
